import type { Ruleset } from './types.js';

/** Rulesets persisted before the Follow Me collapse carried paired high/low flags. */
type StoredRuleset = Ruleset & {
  allowFollowMeHigh?: boolean;
  allowFollowMeLow?: boolean;
};

/**
 * Bring a stored ruleset up to the current shape.
 *
 * The product UI always set the paired flags together, so either flag being
 * off means the user turned Follow Me off.
 */
export function normalizeRuleset(stored: StoredRuleset): Ruleset {
  const { allowFollowMeHigh, allowFollowMeLow, ...rest } = stored;
  return {
    ...rest,
    allowFollowMe:
      stored.allowFollowMe ?? (allowFollowMeHigh !== false && allowFollowMeLow !== false),
  };
}
